<div class="columns-container" [@isCollapsedChanged]="isSafeCollapsed"
    (@isCollapsedChanged.start)="animationStarted($event)" (@isCollapsedChanged.done)="animationDone($event)"
    [ngClass]="{ 'collapsed': isSafeCollapsed && !isClosing && !isOpening }">
    <div class="columns-header">
        <strong [@isClosing]="isClosing">{{columnsPanelTitle}}</strong>
    </div>
    <div class="columns-content">
        <div [@isClosing]="isClosing">
            <div class="columns-content-header">
                <nts-checkbox [value]="!allColumnsHide" (valueChange)="onAllColumnsHideEvent()"
                    [title]="selectDeselectAllTitle"></nts-checkbox>
                <input class="search-columns" [(ngModel)]="filterText" placeholder="{{filterTextPlaceholder}}">
            </div>

            <div cdkDropList class="column-list" (cdkDropListDropped)="drop($event)">

                <div class="column-box" *ngFor="let item of filterFunction()" cdkDrag>
                    <nts-checkbox (valueChange)="onColumnChangeEvent($event, item)" [value]="item.isVisible">
                    </nts-checkbox>
                    <div [title]="item.headerTooltip" class="column-label" (click)="debug(item)">{{item.header}}</div>
                    <div *ngIf="filterText.length === 0" class="column-move-handle" cdkDragHandle>
                        <i class="dx-icon-dragvertical"></i>
                    </div>
                    <div class="column-placeholder" *cdkDragPlaceholder></div>
                </div>
            </div>
        </div>
    </div>
</div>